/* Stock status follows the chosen size, not the first one.

   The product page prints an inventory line ("In stock", "Low stock: 1 left",
   "Out of stock") from product.selected_or_first_available_variant. When the
   shopper has not chosen a size yet, that is whichever size Shopify happens to
   sort first -- so the page read "Low stock: 1 left" while the dropdown still
   said Select size. The number described a size nobody had picked.

   This hides the line until a size is actually selected, and reveals it again
   once one is. It does not touch the text: the theme's own variant-switch code
   (assets/t-product.js) re-renders the inside of #Inventory-<sectionId> for the
   selected variant, and it does that by replacing innerHTML, so the class this
   file toggles on the element itself survives every size change.

   The hiding is done in CSS (dico-card-swipe-fix.css, "Stock status" section)
   with visibility rather than display, so the line reserves its space and
   nothing below it jumps when it appears. Doing the hide in CSS also means the
   wrong value is never painted, not even for a frame.

   Products with a single variant have no picker and nothing to choose, so the
   line shows immediately for them -- handled by the empty-picker case below. */
(function () {
    'use strict';

    var ON = 'dico-inv-on';

    function pickers() {
        return document.querySelectorAll('variant-selects, [id^="variant-selects-"]');
    }

    function statuses() {
        return document.querySelectorAll('inventory-status');
    }

    /* True when the shopper has committed to a size.

       An empty option value is the "Select size" placeholder the size gate adds,
       so it counts as nothing chosen. A page with no picker at all -- a single
       variant product -- has nothing to wait for, so it counts as chosen. */
    function sizeChosen() {
        var roots = pickers();
        if (!roots.length) { return true; }

        var anyControl = false;
        var i, j;

        for (i = 0; i < roots.length; i++) {
            var selects = roots[i].querySelectorAll('select');
            for (j = 0; j < selects.length; j++) {
                anyControl = true;
                var s = selects[j];
                if (s.selectedIndex < 0) { return false; }
                var opt = s.options[s.selectedIndex];
                if (!opt || opt.value === '') { return false; }
            }

            var radios = roots[i].querySelectorAll('input[type="radio"]');
            if (radios.length) {
                anyControl = true;
                if (!roots[i].querySelector('input[type="radio"]:checked')) { return false; }
            }
        }

        return anyControl;
    }

    function apply() {
        var show = sizeChosen();
        var els = statuses();
        for (var i = 0; i < els.length; i++) {
            if (show) {
                els[i].classList.add(ON);
            } else {
                els[i].classList.remove(ON);
            }
        }
    }

    var pending = null;
    function applySoon() {
        if (pending) { window.clearTimeout(pending); }
        pending = window.setTimeout(function () { pending = null; apply(); }, 50);
    }

    function boot() {
        apply();

        /* The shopper's own choice. */
        document.addEventListener('change', applySoon, true);

        /* And again once the theme has finished re-rendering the picker and the
           buy button, which is what makes a value read at change time stale. */
        if (window.MutationObserver) {
            var scope = document.getElementById('mainContent') || document.body;
            new MutationObserver(applySoon).observe(scope, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['selected', 'checked', 'value']
            });
        }

        document.addEventListener('shopify:section:load', applySoon);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
}());
